import GroupsIcon from '@mui/icons-material/Groups';
import { createUserEdit } from '../users/UserEdit';
import { createUserList } from '../users/UserList';

const ClubUsersList = createUserList({
    resource: 'admin/user-management/club-users',
    showRoleFilter: false,
    showImport: false,
    mode: 'club',
});

const ClubUsersEdit = createUserEdit({
    resource: 'admin/user-management/club-users',
    cancelPath: '/admin/user-management/club-users',
    mode: 'club',
});

export default {
    list: ClubUsersList,
    edit: ClubUsersEdit,
    icon: GroupsIcon,
    recordRepresentation: (record: any) => record.name || record.email,
};